<template>
    <div class="fixed h-full w-full photo-background">
        <div class="flex justify-center absolute top-[30px] left-[50%] translate-x-[-50%]">
            <img src="@/assets/sportkit_logo.svg" alt="">
        </div>
        <div class="mt-[84px] flex flex-col align-middle items-center justify-center w-full w-[400px] absolute top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%]">
            <div class="flex justify-center">
                <img src="@/assets/logo.svg" class="logo w-[150px]" >
            </div>
            <div class="flex justify-center w-10/12 text-white text-[21px] mb-[18px] mt-[45px]">
                Hello admin!
            </div>
            <!-- <div 
                :class="{
                        'login-form-input-error' : v$.adminLogin.$error,
                        'login-form-input' : !v$.adminLogin.$error
                        }" 
            >
                <input 
                    v-model="authData.adminLogin" 
                    type="text" 
                    @blur="v$.adminLogin.$touch"  
                    @focus="removePlaceholderLogin" 
                    id="loginInput" 
                    class="input-text bg-transparent text-start placeholder:text-center rounded-[9px] outline-none text-[#FFF] font-medium placeholder:font-medium pl-[10px] w-full placeholder-[#8C8C8C] placeholder:text-[13px] placeholder:relative pr-[20px]" 
                    placeholder="логін"
                >
            </div>
            <div 
                :class="{
                        'login-form-input-error' : v$.adminPassword.$error,
                        'login-form-input' : !v$.adminPassword.$error
                        }"    
            >
                <input 
                    v-model="authData.adminPassword" 
                    type="password" 
                    @blur="v$.adminPassword.$touch"  
                    @focus="removePlaceholderPassword" 
                    id="passwordInput" 
                    class="input-text bg-transparent placeholder:text-center text-start rounded-[9px] outline-none text-[#FFF] font-medium placeholder:font-medium w-full pl-[10px] placeholder-[#8C8C8C] placeholder:relative placeholder:text-[13px]" 
                    placeholder="пароль"
                >
            </div>
            <div class="flex justify-center w-[90%] mt-[10px] mb-[33px]">
                <button @click="processAuthorization" class="bg-[#FECC00] w-full border-[1px] border-[#FECC00] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center mb-[16px]">
                    <div class="w-full text-[20px] text-[#2B2A29] font-extrabold">Log in</div>
                </button>
            </div> -->
            <div class="w-[100%] h-[300px] text-center align-middle flex justify-center items-center px-[50px] text-[24px] rounded-[9px] bg-[#FECC00] border-[2px] border-[#BD252C]">
                <div class="font-bold text-[#BD252C]">ТЕСТОВИЙ ПЕРІОД ЗАВЕРШЕНО</div>
            </div>  
            <div class="">
                <!-- <div class="text-[#FFF] text-[12px] text-center lg:mx-0 w-[355px] mb-[35px] mx-10">
                    Привіт!<br>Це віртуальний кабінет для гравців ФК Минай, якщо у тебе виникли проблеми з доступом, звернись до свого тренера
                </div> -->
            </div>
        </div>
        <div class="text-[#fff] text-[11px] absolute bottom-[30px] opacity-50 text-center w-full">
            © 2023 ALL RIGHTS RESERVED
        </div>
    </div>
</template>

<script>
    import { reactive, onMounted } from 'vue'
    import { getTokens } from '@/services/apiRequests'
    import { useRouter } from 'vue-router'
    import { useVuelidate } from '@vuelidate/core'
    import { required } from '@vuelidate/validators'

    export default {
        setup() {
            const router = useRouter()

            const authData = reactive({
                adminLogin: '',
                adminPassword: ''
            })

            const rules = {
                adminLogin: { required },
                adminPassword: { required }
            }

            const v$ = useVuelidate(rules, authData)

            const processAuthorization = async () => {
                const tokensSetFlag = await getTokens(authData.adminLogin, authData.adminPassword)
                if (tokensSetFlag) {
                    localStorage.adminLogin = authData.adminLogin
                    localStorage.adminPassword = authData.adminPassword
                    router.go()
                } else {
                    authData.adminLogin = ''
                    authData.adminPassword = ''
                }
            }

            onMounted(() => {
                document.addEventListener('keydown', async function(event) {
                    if (event.key === 'Enter') {
                        await processAuthorization()
                    }
                })
            })

            return {
                v$,
                authData,
                processAuthorization,
            }
        }
    }
</script>

<style lang="scss">
    .login-form {
        @apply flex flex-col items-center align-middle justify-center absolute left-[50%] translate-x-[-50%] top-[50%] translate-y-[-50%];
    }

    .login-form-input {
        @apply bg-[#474849] bg-opacity-40 rounded-[9px] items-center px-[13px] border-[1px] border-[#FECC00] flex h-[44px] justify-center w-[90%] mb-[16px];
    }

    .login-form-input-error {
        @apply bg-[#BD252C] bg-opacity-20 rounded-[9px] items-center px-[13px] border-[1px] border-[#BD252C] flex h-[44px] justify-center w-[90%] mb-[16px];
    }

    .login-form-button {
        @apply px-2 py-1 w-[250px] rounded-md bg-[#BD252C] text-white font-semibold;
    }

    .photo-background {
        background: url(@/assets/login_bg.svg) no-repeat center center fixed;
        background-size: cover;
    }
</style>